export default "__VITE_ASSET__CSnCMC2G__"